import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import PlayerCard from '@app/dev/terminal/components/playerCard';

import { formatMoneyAmount } from '@common/helpers/amount';
import { useBalance } from '@app/dev/terminal/hooks/balance';
import { GetCurrencyConfig } from '@common/helpers/selectors';

import './style.scss';

const TransferToUserSuccess = ({
  player,
  amount,
  isMaxAmount,
}) => {
  const [{ closePopup }] = useContext(PopupContext);
  const balance = useBalance();
  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.main.currencySymbolRounding)
  ));

  const visualAmount = isMaxAmount ? balance : amount;

  const t = useTranslation();

  return (
    <div className="popup-content popup-small transfer-to-user-success-popup">
      <h3 className="popup-title">{t('Transfer successful!')}</h3>

      <i onClick={closePopup} className="global-icon icon-Close close-popup" />

      <div className="popup-main-content">
        <i className="global-icon icon-circle-done popup-main-icon" />

        <PlayerCard
          data={player}
          extraRows={[
            {
              label: 'Transfer amount:',
              value: (
                <span className="transfer-to-user-success-amount">
                  {formatMoneyAmount(visualAmount, Config, currencyConfig)}
                </span>
              ),
            },
          ]}
        />
      </div>

      <button
        type="button"
        className="popup-confirm-button"
        onClick={() => closePopup()}
      >
        {t('Ok')}
      </button>
    </div>
  );
};

TransferToUserSuccess.propTypes = {
  player: PropTypes.object.isRequired,
  amount: PropTypes.number,
  isMaxAmount: PropTypes.bool,
};

export default TransferToUserSuccess;
